<template>
  <div class="surveyReport">
    <div class="form_content">
      <el-form :model="basicInfoObj" label-width="120px">
        <!-- 公司信息 -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">公司信息</div>
        </div>
        <!-- <title-bar title="公司信息" /> -->
        <el-row :gutter="100">
          <el-col :span="8">
            <el-form-item label="公司名称：">
              <el-input v-model="basicInfoObj.corporateName" placeholder="请输入" readonly />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="人才供应商：">
              <el-input v-model="basicInfoObj.talentSupplier" placeholder="请输入" readonly />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="100">
          <el-col :span="8">
            <el-form-item label="应聘职位：">
              <el-input v-model="basicInfoObj.recruitmentPosition" placeholder="请输入" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目顾问：">
              <el-input v-model="basicInfoObj.projectConsultant" placeholder="请输入" readonly />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="100">
          <el-col :span="8">
            <el-form-item label="日期：">
              <el-input v-model="basicInfoObj.dateTime" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-form :model="basicInfoObj" label-width="120px">
        <!-- 公文认证 -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">公文认证</div>
        </div>
        <div class="authentication">
          <div class="authentication_left">
            <div class="username_date_of_birth">
              <el-form-item label="姓名：">
                <el-input style="width: 308px" readonly v-model="form.name" />
              </el-form-item>

              <el-form-item label="出生日期：">
                <el-date-picker
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  v-model="form.birthDate"
                  type="date"
                  placeholder="请选择出生日期"
                />
              </el-form-item>
            </div>

            <div class="username_date_of_birth">
              <el-form-item label="身份证号码：">
                <el-input style="width: 308px" readonly v-model="form.idNumber" />
              </el-form-item>

              <el-form-item label="户籍地：">
                <!-- permanentResidenceAddress -->
                <el-input style="width: 308px" readonly v-model="form.permanentResidenceAddress" />
                <CascaderArea
                  v-if="false"
                  country=""
                  province=""
                  city=""
                  @searchArae="searchArae"
                ></CascaderArea>
              </el-form-item>
            </div>
            <div class="username_date_of_birth">
              <el-form-item label="教育背景：">
                <div
                  class="educational_background_item"
                  v-for="(item, index) in codeList.personEducational"
                  :key="index"
                >
                  <!-- 开始年月 -->
                  <div class="start_time">
                    <el-form-item>
                      <el-date-picker
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        v-model="item.startDate"
                        type="date"
                        placeholder="请输入日期"
                        style="width: 150px"
                      />
                    </el-form-item>
                  </div>
                  <span style="margin: 0 6px"> ~ </span>
                  <!-- 结束年月 -->
                  <div class="end_time">
                    <el-form-item>
                      <el-date-picker
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        v-model="item.endDate"
                        type="date"
                        placeholder="日期"
                        style="width: 150px"
                      />
                    </el-form-item>
                  </div>
                  <!-- 学校 -->
                  <div class="school">
                    <el-form-item>
                      <el-input v-model="item.schoolName" placeholder="请输入学校"></el-input>
                    </el-form-item>
                  </div>

                  <!-- 学位 -->
                  <div class="degree">
                    <el-form-item>
                      <el-select v-model="item.education" placeholder="学位">
                        <el-option label="中专" value="中专"></el-option>
                        <el-option label="研究生" value="研究生"></el-option>
                        <el-option label="本科" value="本科"></el-option>
                        <el-option label="大专" value="大专"></el-option>
                        <el-option label="博士" value="博士"></el-option>
                        <el-option label="博士后" value="博士后"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <!-- 专业 -->
                  <div class="specialty">
                    <el-form-item>
                      <el-input v-model="item.major" placeholder="请输入专业"></el-input>
                    </el-form-item>
                  </div>

                  <div class="options_item">
                    <!-- <div class="add_item" @click="clickAddPersonEducationalItem(item, index)">
                    <div class="add_icon">
                      <i
                        style="color: #17757a; font-size: 17px"
                        class="el-icon-circle-plus-outline"
                      ></i>
                    </div>
                    <div class="add_txt">添加</div>
                  </div>

                  <div
                    class="remove_item"
                    v-if="index >= 1"
                    @click="clickRemovePersonEducationalItem(item, index)"
                  >
                    <div class="remove_icon">
                      <i style="color: #fa5050; font-size: 17px" class="el-icon-delete"></i>
                    </div>
                    <div class="remove_txt">删除</div>
                  </div> -->
                  </div>
                </div>
              </el-form-item>
            </div>

            <!-- 工作证明1： -->
            <div
              class="certificate_of_employment"
              v-if="codeList.personExperience && codeList.personExperience.length > 0"
            >
              <el-form-item label="工作证明：">
                <div
                  class="educational_background_item"
                  v-for="(item, index) in codeList.personExperience"
                  :key="index"
                >
                  <!-- 开始年月 -->
                  <div class="start_time">
                    <el-form-item>
                      <el-date-picker
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        v-model="item.inductionTime"
                        type="date"
                        placeholder="请输入日期"
                        style="width: 150px"
                      />
                    </el-form-item>
                  </div>
                  <span style="margin: 0 6px"> ~ </span>
                  <!-- 结束年月 -->
                  <div class="end_time">
                    <el-form-item>
                      <el-date-picker
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        v-model="item.quitTime"
                        type="date"
                        placeholder="日期"
                        style="width: 150px"
                      />
                    </el-form-item>
                  </div>
                  <!-- 请输入公司 -->
                  <div class="school">
                    <el-form-item>
                      <el-input
                        style="width: 372px"
                        v-model="item.companyName"
                        placeholder="请输入公司"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </div>

                  <!-- 岗位 -->
                  <div class="specialty">
                    <el-form-item>
                      <el-input v-model="item.position" placeholder="岗位" readonly></el-input>
                    </el-form-item>
                  </div>

                  <div class="options_item">
                    <!-- <div class="add_item" @click="addCertificateOfEmployment(item, index)">
                    <div class="add_icon">
                      <i
                        style="color: #17757a; font-size: 17px"
                        class="el-icon-circle-plus-outline"
                      ></i>
                    </div>
                    <div class="add_txt">添加</div>
                  </div>

                  <div
                    class="remove_item"
                    v-if="index >= 1"
                    @click="removeCertificateOfEmployment(item, index)"
                  >
                    <div class="remove_icon">
                      <i style="color: #fa5050; font-size: 17px" class="el-icon-delete"></i>
                    </div>
                    <div class="remove_txt">删除</div>
                  </div> -->
                  </div>
                </div>
              </el-form-item>
            </div>
            <!-- 目前工资 -->
            <div class="current_salary">
              <el-form-item label="目前工资：">
                <el-input
                  style="width: 201px"
                  v-model="form.currentSalary"
                  placeholder="请输入工资"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="authentication_right">
            <upload-image :imageUrls.sync="form.headPortrait" />
            <el-button v-if="form.headPortrait" @click="deleteImg" style="margin-top: 10px"
              >删除图片</el-button
            >
          </div>
        </div>

        <!-- 履历核实 -->
        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">履历核实</div>
        </div>
        <div class="resume_verification">
          <el-row :gutter="100">
            <el-col :span="8">
              <el-form-item label="受访对象：">
                <el-input v-model="form.lnterviewees" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="受访对象公司：">
                <el-input v-model="form.targetCompany" placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="100">
            <el-col :span="8">
              <el-form-item label="受访对象岗位：">
                <el-input v-model="form.intervieweePosition" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="受访对象时间：">
                <data-time
                  @dateChange="interviewClick"
                  :parentYear="form.intervieweeYears * 1"
                  :parentMonth="form.intervieweeMonths * 1"
                  :parentDay="form.intervieweeDay * 1"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="100">
            <el-col :span="8">
              <el-form-item label="雇主名称：">
                <el-input v-model="form.employerName" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="岗位名称：">
                <el-input v-model="form.postName" placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="工作关系：">
            <el-tag
              :key="index"
              v-for="(item, index) in form.workingRelationshipss"
              :closable="index > 4"
              :disable-transitions="false"
              :class="{ isActive: form.workingRelationship === item }"
              @close="handleClose(item)"
              @click="tagClick((form.workingRelationship = item))"
            >
              {{ item }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">
              + 自定义
            </el-button>
          </el-form-item>
          <el-form-item label="工作时间：">
            <div class="work-time">
              <data-time
                @dateChange="startTimeClick"
                :parentYear="form.workingHoursYears ? form.workingHoursYears * 1 : 0"
                :parentMonth="form.workingHoursMonths ? form.workingHoursMonths * 1 : 0"
                :isShowDay="false"
              />~&nbsp;
              <data-time
                @dateChange="endTimeClick"
                :parentYear="form.endWorkingTimeYears ? form.endWorkingTimeYears * 1 : 0"
                :parentMonth="form.endWorkingTimeMonths ? form.endWorkingTimeMonths * 1 : 0"
                :isShowDay="false"
              />
            </div>
          </el-form-item>
          <el-form-item label="工作职责：">
            <el-input
              v-model="form.operatingDuty"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="工作表现：">
            <el-input
              v-model="form.workPerformance"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="工作态度：">
            <el-input
              v-model="form.workingAttitude"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="性格：">
            <el-input
              v-model="form.characters"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="职业操守：">
            <el-input
              v-model="form.professionalEthics"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="人际关系：">
            <el-input
              v-model="form.interpersonalRelationship"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="有待提升：">
            <el-input
              v-model="form.improved"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              placeholder="请输入"
            />
          </el-form-item>
          <div class="current_salary">
            <div class="current_salary_title">当时薪资：</div>
            <el-form-item class="new_left">
              <div class="menony_flex">
                <div class="menony_flex_left">
                  <div class="menony_flex_item">
                    <span>年薪：</span>
                    <el-input v-model="form.currentSalary" />
                  </div>
                </div>
                <div class="menony_flex_center">
                  <span>薪资构成</span>
                  <div></div>
                </div>
                <div class="menony_flex_right">
                  <div class="menony_flex_right_li">
                    <div class="menony_flex_item">
                      <span>固定月薪：</span>
                      <el-input v-model="form.currentMonthlySalary" />
                    </div>
                    <div class="menony_flex_item">
                      <span>年度奖金：</span>
                      <el-input v-model="form.currentAnnualBonus" />
                    </div>
                  </div>
                  <div class="menony_flex_right_li">
                    <div class="menony_flex_item">
                      <span>绩效奖金：</span>
                      <el-input v-model="form.currentPerformanceBonus" />
                    </div>
                    <div class="menony_flex_item">
                      <span>提成：</span>
                      <el-input v-model="form.currentPercentage" />
                    </div>
                  </div>
                  <div class="menony_flex_right_li">
                    <div class="menony_flex_right_li_item">
                      <span>其他：</span>
                      <el-input v-model="form.currentOther" type="textarea" :rows="3" />
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>

          <el-form-item label="离职原因：">
            <el-input
              v-model="form.reasonsResignation"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              placeholder="请输入"
            />
          </el-form-item>

          <el-form-item label="劳动争议：">
            <el-radio-group v-model="form.laborDispute">
              <el-radio v-for="(item, index) in extraInfo" :key="index" :label="item.value">
                {{ item.value }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="违禁行为：">
            <el-radio-group v-model="form.prohibited">
              <el-radio v-for="(item, index) in extraInfo" :key="index" :label="item.value">
                {{ item.value }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="竞业禁止协议：">
            <el-radio-group v-model="form.competeAgreement">
              <el-radio v-for="(item, index) in extraInfo" :key="index" :label="item.value">
                {{ item.value }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <div class="title_main">
          <div class="line"></div>
          <div class="title_main_txt">附录</div>
        </div>
        <el-row :gutter="100">
          <el-col :span="6">
            <el-form-item label="身份证正面">
              <upload-image :imageUrls.sync="form.frontIdCard" />
              <el-button
                v-if="form.frontIdCard"
                @click="deleteImgTwo('身份证正面')"
                style="margin-top: 10px"
              >
                删除图片
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="身份证反面">
              <upload-image :imageUrls.sync="form.reverseIdCard" />
              <el-button
                v-if="form.reverseIdCard"
                @click="deleteImgTwo('身份证反面')"
                style="margin-top: 10px"
              >
                删除图片
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="100">
          <el-col :span="6">
            <el-form-item label="院校毕业证">
              <upload-image :imageUrls.sync="form.collegeGraduation" />
              <el-button
                v-if="form.collegeGraduation"
                @click="deleteImgTwo('院校毕业证')"
                style="margin-top: 10px"
              >
                删除图片
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="院校学院证">
              <upload-image :imageUrls.sync="form.collegeCertificate" />
              <el-button
                v-if="form.collegeCertificate"
                @click="deleteImgTwo('院校学院证')"
                style="margin-top: 10px"
              >
                删除图片
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 操作 -->
    <div class="option_button">
      <!-- 保存 -->
      <div class="save" @click="save" v-if="showAutingBtn == '0'">保存</div>
      <!-- 下载 -->
      <div class="download" @click="download" v-if="showAutingBtn == '0'">下载报告</div>
      <!-- 返回上一页 -->
      <div class="back" @click="$router.go(-1)" v-if="showAutingBtn == '0'">返回上级</div>
      <div class="save" @click="auditingNoY" v-if="showAutingBtn == '1'">审核通过</div>
      <!-- 下载 -->
      <!-- <div class="download" @click="download">导出报告</div> -->
      <!-- 返回上一页 -->
      <div class="back" @click="auditingNo" v-if="showAutingBtn == '1'">审核不通过</div>
    </div>

    <!-- 审核不通过弹窗 -->
    <el-dialog :visible.sync="auditingNoDialogVisible" width="40%" :before-close="handleCloseA">
      <div class="auditingNo">
        <div class="title"><span></span><span>审核不通过</span></div>
      </div>
      <div style="padding: 50px 50px 0 40px">
        <el-form
          label-position="left"
          label-width="100px"
          :model="auditingNoForm"
          :rules="auditingNoRules"
        >
          <div style="display: flex">
            <el-form-item label="驳回理由：" prop="rejectionReason">
              <el-select
                v-model="auditingNoForm.rejectionReason"
                placeholder="请选择"
                @change="rejectionReasonChange"
                clearable
                :disabled="auditingDisabled"
              >
                <el-option v-for="item in options" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-radio-group v-model="info">
                <el-radio
                  :label="1"
                  :disabled="rejectionDisabled"
                  @click.native="pendingRes($event)"
                  >自定义理由</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label="驳回理由：" v-if="info == 1">
            <el-input
              v-model="auditingNoForm.rejectionReason"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 20 }"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="auditingNoFn">保 存</el-button>
        <el-button @click="handleCloseA">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CascaderArea from '@/components/CascaderArea'
import DataTime from '@/components/DataTime.vue'
import UploadImage from '@/components/UploadImage.vue'
import {
  BackgroundInvestigationReport,
  getParticularsPersonByid,
  BackgroundInvestigationReportSave,
  backgroundInvestigationReport
} from '@/api/projectCenter.js'
import { agree, reject, rejectionType } from '@/api/jingyiProject.js'
export default {
  components: {
    CascaderArea,
    UploadImage,
    DataTime
  },
  props: {
    PreCode: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    reviewCode: {
      type: String,
      required: true
    },
    showAutingBtn: {
      type: Number
    },
    // 项目id
    projectCode: {
      tyrpe: String
    }
  },
  data() {
    return {
      auditingDisabled: false, //控制驳回理由下拉状态
      rejectionDisabled: false, //控制自定义理由状态
      auditingNoDialogVisible: false, //审核不通过弹窗显示
      options: [], //驳回理由数据
      radio: 0, //驳回理由
      //审核不通过表单数据
      info: 0, //是否显示自定义驳回理由
      auditingNoForm: {
        rejectionReason: '', //驳回理由
        rejectionType: '', //驳回理由类型（自定义）
        reviewCode: '' //审核编号审核编号
      },
      //审核不通过表单校验
      auditingNoRules: {
        rejectionReason: [{ required: true, message: '请选择驳回理由', trigger: 'change' }]
      },

      basicInfoObj: {
        corporateName: '', // 公司名称
        talentSupplier: '菁锐人才', // 人才供应商
        recruitmentPosition: '', // 应聘职位
        projectConsultant: '', // 项目顾问
        dateTime: this.$df(new Date().getTime(), 'yyyy-mm-dd') // 日期
      },

      form: {
        characters: '',
        collegeCertificate: '',
        collegeCertificateKey: '',
        collegeGraduation: '',
        collegeGraduationKey: '',
        competeAgreement: '',
        createName: '',
        createTime: '',
        currentAnnualBonus: '',
        currentMonthlySalary: '',
        currentOther: '',
        currentPercentage: '',
        currentPerformanceBonus: '',
        currentSalary: '',
        employerName: '',
        endWorkingTime: '',
        endWorkingTimeMonths: '',
        endWorkingTimeYears: '',
        frontIdCard: '',
        frontIdCardKey: '',
        headPortrait: '',
        id: '',
        improved: '',
        interpersonalRelationship: '',
        intervieweeDay: 0,
        intervieweeMonths: 0,
        intervieweePosition: '',
        intervieweeTime: '',
        intervieweeYears: 0,
        laborDispute: '',
        lnterviewees: '',
        operatingDuty: '',
        personnelId: '',
        postName: '',
        professionalEthics: '',
        prohibited: '',
        projectId: '',
        reasonsResignation: '',
        reverseIdCard: '',
        reverseIdCardKye: '',
        targetCompany: '',
        updateName: '',
        updateTime: '',
        workPerformance: '',
        workingAttitude: '',
        workingHours: '',
        workingHoursMonths: '',
        workingHoursYears: '',
        workingRelationship: '',
        workingRelationships: '',
        workingRelationshipss: []
      },
      inputVisible: false, // el-tag的input框
      inputValue: '', // 输入框的值
      extraInfo: [{ value: '有' }, { value: '无' }, { value: '不确定' }],
      codeList: {
        personEducational: []
      }
    }
  },
  computed: {},
  watch: {},
  methods: {
    pendingRes(event) {
      if (event.target.tagName === 'INPUT') {
        let id = event.target.value
        if (this.info != id) {
          this.auditingDisabled = true
          this.auditingNoRules.rejectionReason[0].required = false
          this.auditingNoRules.rejectionReason[0].message = ''
        } else {
          this.auditingDisabled = false
          this.auditingNoRules.rejectionReason[0].required = true
          this.auditingNoRules.rejectionReason[0].message = '请选择驳回理由'
          this.info = 0
        }
      }
    },
    //选中审核不通过改变事件
    rejectionReasonChange(val) {
      if (val) {
        this.rejectionDisabled = true
      } else {
        this.rejectionDisabled = false
      }
    },
    // 关闭审核不通过弹窗
    handleCloseA(done) {
      this.auditingNoDialogVisible = false
      this.info = 0
      this.auditingDisabled = false
      this.rejectionDisabled = false
      this.auditingNoForm = {
        rejectionReason: '', //驳回理由
        rejectionType: '', //驳回理由类型（自定义）
        reviewCode: '' //审核编号审核编号
      }
      this.auditingNoRules.rejectionReason[0].require = false
      this.search()
      done()
    },
    // 查询拒绝理由
    async getRejectionType() {
      const { data } = await rejectionType({
        type: '024'
      })
      if (data.resultCode == 200) {
        this.options = data.data
      }
    },
    //审核通过
    async auditingNoY() {
      const { data: res } = await agree({
        reviewCode: this.reviewCode
      })
      if (res.resultCode == 200) {
        this.$message.success('审核成功')
        this.auditingNoDialogVisible = false
        this.info = 0
        this.auditingDisabled = false
        this.rejectionDisabled = false
        this.auditingNoRules.rejectionReason[0].require = false
        this.auditingNoForm = {
          rejectionReason: '', //驳回理由
          rejectionType: '', //驳回理由类型（自定义）
          reviewCode: '' //审核编号审核编号
        }
        this.search()
        // this.$router.push({
        //   path: '/businessManagement/JingyiProject'
        // })
      }
    },
    // 打开审核不通过弹窗
    auditingNo() {
      this.auditingNoDialogVisible = true
    },
    // 审核不通过弹窗保存
    async auditingNoFn() {
      this.auditingNoForm.reviewCode = this.reviewCode
      const { data } = await reject(this.auditingNoForm)
      if (data.resultCode == 200) {
        this.$message.success(data.message)
        this.auditingNoDialogVisible = false
        this.search()
        this.$router.push({
          path: '/businessManagement/JingyiProject'
        })
      }
    },

    async getCode() {
      let PreCode = this.PreCode
      const { data: res } = await getParticularsPersonByid({
        PreCode
      })
      if (res.resultCode == 200) {
        this.codeList = res.data
      }
    },
    // 户籍地
    searchArae(val) {
      console.log(val)
    },

    clickAddPersonEducationalItem(item, index) {
      this.form.list.push({})
    },
    clickRemovePersonEducationalItem(item, index) {
      this.form.list.splice(index, 1)
    },

    addCertificateOfEmployment(item, index) {
      this.form.list2.push({})
    },
    removeCertificateOfEmployment(item, index) {
      this.form.list2.splice(index, 1)
    },

    async download() {
      this.form.projectId = this.item.id
      this.form.personnelId = this.PreCode
      const { data: res } = await BackgroundInvestigationReportSave(this.form)
      if (res.resultCode == 200) {
        const { data: resS } = await backgroundInvestigationReport({
          personCode: this.PreCode,
          projectId: this.projectCode
        })
        if (resS) {
          let blob = new Blob([resS])
          let href = window.URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
          const a = document.createElement('a') //创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载'链接
          a.download = `人才背景报告.pdf` //指定下载文件名
          // a.download = "test.png";
          a.click() //触发下载
          window.URL.revokeObjectURL(a.href) //释放URL对象
          if (document.body.contains(a)) {
            document.body.removeChild(a) //释放标签
          }
          //  else {
          //   this.$message.error('导出失败!')
          // }
        }
      }
      // console.log(this.item);
    },

    deleteImg() {
      this.form.companyLogo = ''
      this.form.headPortrait = ''
    },
    interviewClick(year, month, day) {
      this.form.intervieweeYears = year
      this.form.intervieweeMonths = month
      this.form.intervieweeDay = day
    },
    handleClose(tag) {
      this.form.workingRelationshipss.splice(this.form.workingRelationshipss.indexOf(tag), 1)
    },
    startTimeClick(year, month) {
      this.form.workingHoursYears = year
      this.form.workingHoursMonths = month
    },
    endTimeClick(year, month) {
      this.form.endWorkingTimeYears = year
      this.form.endWorkingTimeMonths = month
    },
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.form.workingRelationshipss.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    deleteImgTwo(name) {
      switch (name) {
        case '身份证正面':
          this.form.frontIdCard = ''
          break

        case '身份证反面':
          this.form.reverseIdCard = ''
          break

        case '院校毕业证':
          this.form.collegeGraduation = ''
          break

        case '院校学院证':
          this.form.collegeCertificate = ''
          break
      }
    },
    async search() {
      // console.log(this.$route.query.PreCode)
      let id = this.$route.query.PreCode
      const { data: res } = await BackgroundInvestigationReport({ id })
      if (res.resultCode == 200) {
        if (res.data) {
          this.form = res.data
          this.basicInfoObj.projectConsultant = res.data.projectConsultant
        }
      }
    },
    async save() {
      this.form.projectId = this.item.id
      this.form.personnelId = this.PreCode
      const { data: res } = await BackgroundInvestigationReportSave(this.form)
      console.log(res)
      if (res.resultCode == 200) {
        this.$message.success('保存成功')
        this.$router.go(-1)
      }
    }
  },
  created() {
    this.search()
    this.getCode()
    this.getRejectionType()
    this.basicInfoObj.corporateName = this.item.corporateName
    this.basicInfoObj.recruitmentPosition = this.item.recruitmentPosition
    if (this.itemprojectManagers) {
      let projectConsultant = this.item.projectManagers.join(',')
      this.basicInfoObj.projectConsultant = projectConsultant
    }
  },
  mounted() {}
}
</script>
<style scoped lang="less">
.surveyReport {
  background: #fff;
  padding: 20px 16px;
  position: relative;

  .form_content {
    height: calc(100vh - 208px - 72px);
    overflow: auto;
    padding-bottom: 72px;
  }

  .title_main {
    display: flex;
    align-items: center;

    margin-bottom: 20px;

    .line {
      width: 4px;
      height: 18px;
      border-radius: 4px;
      background-color: #17757a;
      margin-right: 4px;
    }

    .title_main_txt {
      font-size: 15px;
      font-weight: 600;
      color: #17757a;
    }
  }

  .authentication {
    display: flex;

    .authentication_left {
      .username_date_of_birth {
        display: flex;

        .educational_background_item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          /deep/.el-form-item {
            margin: 0;
          }

          /deep/.el-form-item__content {
            margin-left: 0 !important;
          }

          .start_time {
            /deep/.el-input__inner {
              width: 150px;
            }
          }

          .end_time {
            margin-right: 8px;

            /deep/.el-input__inner {
              width: 150px;
            }
          }

          .school {
            margin-right: 8px;

            /deep/.el-input__inner {
              width: 266px;
            }
          }

          .degree {
            margin-right: 8px;

            /deep/.el-input__inner {
              width: 98px;
            }
          }

          .specialty {
            /deep/.el-input__inner {
              width: 233px;
            }

            margin-right: 28px;
          }

          .options_item {
            display: flex;

            .add_item {
              display: flex;
              cursor: pointer;
              margin-right: 8px;

              .add_icon {
                margin-right: 4px;
              }

              .add_txt {
                font-size: 14px;
                color: #17757a;
              }
            }

            .remove_item {
              display: flex;
              cursor: pointer;

              .remove_icon {
                margin-right: 4px;
              }

              .remove_txt {
                font-size: 14px;
                color: #333333;
              }
            }
          }
        }
      }

      .certificate_of_employment {
        .educational_background_item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          /deep/.el-form-item {
            margin: 0;
          }

          /deep/.el-form-item__content {
            margin-left: 0 !important;
          }

          .start_time {
            /deep/.el-input__inner {
              width: 150px;
            }
          }

          .end_time {
            margin-right: 8px;

            /deep/.el-input__inner {
              width: 150px;
            }
          }

          .school {
            margin-right: 8px;

            /deep/.el-input__inner {
              width: 372px;
            }
          }

          .specialty {
            /deep/.el-input__inner {
              width: 233px;
            }

            margin-right: 28px;
          }

          .options_item {
            display: flex;

            .add_item {
              display: flex;
              cursor: pointer;
              margin-right: 8px;

              .add_icon {
                margin-right: 4px;
              }

              .add_txt {
                font-size: 14px;
                color: #17757a;
              }
            }

            .remove_item {
              display: flex;
              cursor: pointer;

              .remove_icon {
                margin-right: 4px;
              }

              .remove_txt {
                font-size: 14px;
                color: #333333;
              }
            }
          }
        }
      }
    }

    .authentication_right {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      /deep/.avatar {
        width: 138px;
        height: 138px;
      }
    }
  }

  .resume_verification {
    .work-time {
      display: flex;
    }

    // 当时薪资
    .current_salary {
      .current_salary_title {
        padding-left: 28px;
        color: #333333;
        font-size: 14px;
      }

      .new_left {
        /deep/ .el-form-item__content {
          margin-left: 0 !important;
        }

        .menony_flex {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;

          .menony_flex_item {
            display: flex;
            flex-direction: row;
            align-items: center;

            span {
              display: block;
              color: #606266;
              font-size: 14px;
              width: 80px;
              text-align: right;
            }

            /deep/ .el-input {
              width: 211px;
            }
          }

          .menony_flex_left {
            margin-right: 40px;
            overflow: hidden;
            width: 18%;
          }

          .menony_flex_center {
            transform: translateY(-13px);
            width: 12%;
            margin-right: 40px;
            font-size: 14px;
            align-items: center;
            color: #000;
            display: flex;
            flex-direction: column;

            /deep/ span {
              line-height: 20px !important;
            }

            div {
              width: 100%;
              position: relative;
              height: 2px;
              margin-top: 8px;
              background-color: #eee;
            }

            div:before {
              position: absolute;
              top: 50%;
              right: 0;
              margin-top: -4px;
              content: ' ';
              display: inline-block;
              height: 6px;
              width: 6px;
              border-width: 2px 2px 0 0;
              border-color: #c8c8cd;
              border-style: solid;
              -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
              transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
            }

            div:after {
              content: ' ';
              position: absolute;
              right: 0;
              top: 0;
              width: 1px;
              bottom: 0;
              border-right: 1px solid #d9d9d9;
              color: #d9d9d9;
              -webkit-transform-origin: 100% 0;
              transform-origin: 100% 0;
              -webkit-transform: scaleX(0.5);
              transform: scaleX(0.5);
            }
          }

          .menony_flex_right {
            flex: 1;
            overflow: hidden;

            /deep/ .el-input {
              width: 184px !important;
            }

            .menony_flex_right_li {
              display: flex;
              flex-direction: row;
              margin-bottom: 20px;
            }

            .menony_flex_right_li_item {
              width: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: row;
              align-items: center;

              span {
                display: block;
                color: #606266;
                font-size: 14px;
                width: 80px;
                text-align: right;
              }

              /deep/.el-textarea__inner {
                width: 592px;
              }

              /deep/.el-textarea {
                width: 592px;
              }
            }
          }
        }
      }
    }
  }

  /deep/.avatar-uploader-icon {
    width: 174px;
  }

  /deep/.avatar {
    width: 174px;
  }

  .option_button {
    display: flex;
    margin-top: 50px;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 72px;
    left: 0;
    bottom: 0;
    background: #fff;
    width: 100%;
    box-shadow: 0px 0px 4px 0px #00000040;

    .save {
      width: 121px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      background-color: #17757a;
      margin-right: 10px;
      cursor: pointer;
    }

    .download {
      width: 121px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      margin-right: 10px;
      background-color: #17757a;
      cursor: pointer;
    }

    .back {
      width: 121px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #17757a;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      border: 1px solid #17757a;
      cursor: pointer;
    }
  }
}
</style>
